import Page from 'components/pages/article-slug'
import initRequest from 'request/article-slug/init'

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking'
  }
}

export async function getStaticProps({ params }) {
  const initData = await initRequest({ slug: params.slug || '' })
  if (!initData) return { notFound: true }
  return { props: initData, revalidate: process.env.ARTICLE_CACHE_DURATION || 60 * 10 }
}

export default function ArticleSlug(initData) {
  const t = useI18n()
  const router = useRouter()
  const { description, cover } = initData.article
  const articleTitle = initData.article.title
  const title = t.seo.title(articleTitle, { raw: true })
  const year = dayjs().year()
  const url = router.url
  return (
    <>
      <C.Head>
        { h.seo({ title, description }) }
        { h.og({
          type: 'article',
          image: cover
        }) }
        { h.ldjson({
          '@context': 'http://schema.org/',
          '@type': 'BreadcrumbList',
          'itemListElement': [{
            'position': 1,
            '@type': 'ListItem',
            'item': {
              '@id': h.path.full.root(),
              'name': 'StyleMap'
            }
          }, {
            'position': 2,
            '@type': 'ListItem',
            'item': {
              '@id': h.path.full.styles(),
              'name': t('seo:styles.title', { year })
            }
          }, {
            'position': 3,
            '@type': 'ListItem',
            'item': {
              '@id': url,
              'name': articleTitle
            }
          }]
        }) }
        { h.ldjson({
          '@context': 'http://schema.org/',
          '@type': 'FAQPage',
          '@id': url,
          'headline': articleTitle,
          'mainEntity': [
            {
              '@type': 'Question',
              'name': t('seo:faq.question1'),
              'acceptedAnswer': {
                '@type': 'Answer',
                'text': t('seo:faq.answer1', { url })
              }
            },
            {
              '@type': 'Question',
              'name': t('seo:faq.question2'),
              'acceptedAnswer': {
                '@type': 'Answer',
                'text': t('seo:faq.answer2', { url })
              }
            }
          ]
        }) }
      </C.Head>
      <Page initData={ initData } />
    </>
  )

}
